import{m as n}from"./chunk-HBP5N4FR.js";n();var d=()=>{let e=typeof window!="undefined"?window:{};return Boolean(e.isOpera&&e.elrond)};export{d as a};
//# sourceMappingURL=chunk-XAN6ZSE2.js.map
